export const lockOrientation = () => {
	const bestOrientation = 'natural';
	window.screen.orientation.lock(bestOrientation);
}
